import type { CSSProperties } from 'react';

/** 中国地图 GeoJSON（DataV 公开数据） */
export const CHINA_GEO_JSON_URL = '/map/100000_full.json';

/** 默认全国视角：向北、向内陆偏，减少南海占比 */
export const MAINLAND_LNGLAT: [number, number, number] = [106.1, 35.6, 0];

export const CHINA_OVERVIEW_DISTANCE = 80;
export const GEO_REGION_HEIGHT = 2.2;

/** 顶栏标题 `.dash-title-bar__text` 为 22px，省级名略小一号以保证层级 */
export const CHINA_MAP_LABEL_FONT_SIZE = 16;

/** 省份下钻后，地图区域标签字号 */
export const PROVINCE_MAP_LABEL_FONT_SIZE = 16;

/** 省份下钻默认相机距离相对原公式再拉远约 22%，减少被侧栏裁切 */
export const PROVINCE_VIEW_DISTANCE_SCALE = 1.8;

/** 散点 Z：高于挤出顶面，减少与侧面/顶面的深度与拾取竞争 */
export const SCATTER_ALTITUDE = GEO_REGION_HEIGHT + 1.2;

export const GEO3D_EMPHASIS_HOVER = {
  disabled: false,
  label: { show: false },
  itemStyle: {
    color: '#1e4d7a',
    opacity: 1,
    borderWidth: 0.85,
    borderColor: '#1ad1e8',
  },
} as const;

export const containerStyle: CSSProperties = {
  width: '100%',
  height: '100%',
  minHeight: 320,
  position: 'relative',
};

export const loadingStyle: CSSProperties = {
  position: 'absolute',
  inset: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'rgba(4, 13, 33, 0.82)',
  zIndex: 2,
  fontSize: 14,
  color: '#8cadc9',
};

export const provinceLoadingStyle: CSSProperties = {
  ...loadingStyle,
  background: 'rgba(4, 13, 33, 0.45)',
  zIndex: 3,
  pointerEvents: 'none',
  fontSize: 13,
};

/** 右上操作区；`right` 由 EchartsMap 按 `layoutChromeRightInsetPx` 覆盖以随可伸缩右侧面板变化 */
export const mapBackBtnWrapStyle: CSSProperties = {
  position: 'absolute',
  left: 'auto',
  right: 316,
  top: 88,
  zIndex: 60,
  pointerEvents: 'auto',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'flex-end',
  flexWrap: 'wrap',
  gap: 10,
};

/** 「返回全国」「恢复默认」共用：字号、圆角、边框、色板一致 */
export const mapActionBtnStyle: CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 6,
  minHeight: 32,
  padding: '6px 14px',
  borderRadius: 6,
  border: '1px solid rgba(0, 229, 229, 0.45)',
  background: 'linear-gradient(180deg, rgba(12, 40, 72, 0.92), rgba(6, 22, 44, 0.88))',
  color: '#e6f7ff',
  fontSize: 14,
  fontWeight: 500,
  lineHeight: 1.2,
  cursor: 'pointer',
  boxShadow: '0 2px 12px rgba(0, 0, 0, 0.35)',
  backdropFilter: 'blur(6px)',
};

/** @deprecated 使用 mapActionBtnStyle */
export const mapBackBtnStyle = mapActionBtnStyle;

/** ZRender 拖拽与点击区分的像素阈值 */
export const DRAG_THRESHOLD_PX = 4;
